import React from 'react';
import { motion } from 'framer-motion';
import { Home, Clock, Power } from 'lucide-react';
export const HowItWorks = () => {
  const steps = [{
    icon: <Home className="w-8 h-8 text-white" data-id="element-92" />,
    title: 'Prepara el ambiente',
    desc: 'Configuras la "Cueva del Sueño" siguiendo nuestras instrucciones de ingeniería sensorial.',
    gradient: 'from-brand-navy to-brand-navyLight',
    glow: 'shadow-[0_4px_20px_rgba(26,43,72,0.35)]',
    cardBg: 'bg-white border border-brand-navy/10'
  }, {
    icon: <Clock className="w-8 h-8 text-white" data-id="element-93" />,
    title: 'Sincroniza el reloj',
    desc: 'Aplicas la Ventana de los 90 Minutos para acostar a tu bebé antes de que se dispare el cortisol.',
    gradient: 'from-brand-lavender to-brand-teal',
    glow: 'shadow-[0_4px_20px_rgba(155,173,193,0.4)]',
    cardBg: 'bg-white border border-brand-lavender/20'
  }, {
    icon: <Power className="w-8 h-8 text-white" data-id="element-94" />,
    title: 'Ejecuta el Reset',
    desc: 'Sigues el protocolo de 72 horas para enseñar a su cerebro que la cuna es un lugar seguro para el descanso autónomo.',
    gradient: 'from-brand-amber to-yellow-500',
    glow: 'shadow-[0_4px_20px_rgba(212,175,55,0.4)]',
    cardBg: 'bg-white border border-brand-amber/20'
  }];
  return <section className="py-20 px-6 bg-brand-cream" data-id="element-95">
      <div className="max-w-5xl mx-auto" data-id="element-96">
        <div className="text-center mb-16" data-id="element-97">
          <h2 className="text-3xl md:text-4xl font-bold text-brand-navy mb-4" data-id="element-98">
            Cómo funciona el método
          </h2>
          <p className="text-lg text-brand-charcoal/70 max-w-2xl mx-auto" data-id="element-99">
            Tres pasos simples basados en la biología de tu bebé, no en reglas
            arbitrarias.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 relative" data-id="element-100">
          {/* Connector line for desktop */}
          <div className="hidden md:block absolute top-12 left-[16%] right-[16%] h-1 bg-gradient-to-r from-brand-navy via-brand-lavender to-brand-amber rounded-full z-0" data-id="element-101"></div>

          {steps.map((step, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.2
        }} className={`relative z-10 flex flex-col items-center text-center p-6 rounded-2xl ${step.cardBg}`} data-id="element-102">
              <div className={`w-24 h-24 bg-gradient-to-br ${step.gradient} rounded-full ${step.glow} flex items-center justify-center mb-6 relative`} data-id="element-103">
                <div className="absolute -top-2 -right-2 w-8 h-8 bg-gradient-to-br from-brand-amber to-yellow-500 text-brand-navy rounded-full flex items-center justify-center font-bold shadow-md text-sm" data-id="element-104">
                  {i + 1}
                </div>
                {step.icon}
              </div>
              <h3 className="text-xl font-bold text-brand-navy mb-3" data-id="element-105">
                {step.title}
              </h3>
              <p className="text-brand-charcoal/80 leading-relaxed" data-id="element-106">
                {step.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
};